import { cn } from '../../lib/utils';
import { Measurement } from '../../types/Measurement';

type MeasurementUnitProps = {
    measurement: Measurement;
    className?: string;
};

export const MeasurementUnit = ({ measurement, className }: MeasurementUnitProps) => {
    return (
        <span className={cn('whitespace-nowrap', className)}>{`${Number(measurement.amount) ? measurement.amount : 0} ${
            measurement.unit ? measurement.unit : ''
        }`}</span>
    );
};
